<template>
  <van-popup v-model="visible" position="top" :style="{ height: '45%' }">
    <div class="slayerContent" @click.stop>
      <!-- 固定搜索头 -->
      <div class="search-header">
        <div class="searchInput">
          <div class="searchLeft" @click="showTypeSheet = true">
            <span>{{ searchName }}</span>
            <label></label>
          </div>
          <van-action-sheet v-model="showTypeSheet" :actions="searchTypes" @select="onTypeSelect" />
          <div class="searchRight">
            <input type="text" v-model="keyword" placeholder="请输入..." @keyup.enter="doSearch" @input="onInputChange">
            <div class="voice-btn" :class="{ recording: isRecording, disabled: !supportVoice }" @click="toggleVoiceSearch">
              <van-icon name="audio" size="18" />
            </div>
            <label @click="doSearch">搜索</label>
          </div>
        </div>
        <!-- 下拉联想列表 -->
        <div class="suggest-list" v-if="showSuggest && suggestList.length > 0">
          <div class="suggest-item" v-for="(item, index) in suggestList" :key="index" @click="selectSuggest(item)">
            <van-icon name="search" size="14" color="#999" />
            <span>{{ item.name || item.siteName }}</span>
          </div>
        </div>
      </div>
      
      <!-- 可滚动内容区 -->
      <div class="scroll-content">
        <!-- 热门搜索 & 历史搜索 -->
        <div v-if="!showResult">
        <div class="hotsearch">
          <div class="hotsearchTitle">
            <img src="../assets/imgs/hot.png">
            <span>热门搜索</span>
          </div>
          <div class="hotsearchList">
            <div class="hotsearchItem" v-for="item in hotList" :key="item.id" @click="quickSearch(item.searchWord)">
              {{ item.searchWord }}
            </div>
          </div>
        </div>
        <div style="height: 0.4rem;"></div>
        <div class="historysearch">
          <div class="historysearchTitle">
            <span></span>
            <label>历史搜索</label>
            <i v-if="historyList.length > 0" @click="clearHistory">清空</i>
          </div>
          <div class="historyResult" v-if="historyList.length > 0">
            <div class="history-item" v-for="(item, index) in historyList" :key="index">
              <span @click="quickSearch(item)">{{ item }}</span>
              <van-icon name="cross" size="12" color="#999" @click.stop="removeHistory(index)" />
            </div>
          </div>
          <div class="historyResult1" v-else>暂无历史搜索结果</div>
        </div>
      </div>
      
      <!-- 搜索结果 -->
      <div class="searchResultBox" v-if="showResult">
        <div class="historysearchTitle">
          <span></span>
          <label>{{ selectedItem ? '可办理网点' : '搜索结果' }}</label>
          <i @click="handleBack">{{ selectedItem ? '返回事项' : '返回' }}</i>
        </div>
        <!-- 智能转换提示 -->
        <div class="smart-tip" v-if="smartTip">
          <van-icon name="bulb-o" size="14" />
          <span>{{ smartTip }}</span>
        </div>
        
        <!-- 事项搜索结果 -->
        <div class="itemResList" v-if="searchType === 2 && itemResultList.length > 0 && !selectedItem">
          <div class="itemResCard" v-for="item in itemResultList" :key="item.id || item.projectId" @click="selectItem(item)">
            <div class="item-info">
              <div class="item-name">{{ item.name }}</div>
              <div class="item-tags">
                <span class="category-tag">{{ item.category }}</span>
                <span class="recommend-tag" :class="item.recommend">{{ getHandleLabel(item.recommend) }}</span>
              </div>
            </div>
            <div class="item-arrow">
              <span class="site-count" v-if="item.siteIds && item.siteIds.length > 0">{{ item.siteIds.length }}个网点可办</span>
              <span class="site-count" v-else>查看详情</span>
              <van-icon name="arrow" size="14" color="#999" />
            </div>
          </div>
        </div>
        
        <!-- 网点列表（政务中心搜索或事项选中后） -->
        <div class="historyResList" v-if="resultList.length > 0 || selectedItem">
          <div class="historyResItem" v-for="site in resultList" :key="site.id || site.siteId" @click="selectSite(site)">
            <div class="historyResItemTitle">
              <span>{{ site.siteName }}</span>
              <van-icon name="arrow" size="0.35rem" />
            </div>
            <div class="historyResItemContent">
              <div class="resItemAddress">
                <img src="../assets/imgs/address.png">
                <span>{{ site.address }}</span>
              </div>
              <div class="resItemTime">
                <img src="../assets/imgs/time.png">
                <span>{{ site.time }}</span>
              </div>
              <div class="resItemBus">
                <img src="../assets/imgs/road.png">
                <span>交通指引：{{ site.traffic }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="noResult" v-if="(resultList.length === 0 && itemResultList.length === 0) || (selectedItem && resultList.length === 0)">
          <div class="empty-icon">
            <van-icon name="search" size="48" color="#ddd" />
          </div>
          <div class="empty-text">{{ selectedItem ? '该事项暂无可办理网点' : (searchType === 1 ? '未找到相关网点' : '暂无搜索结果') }}</div>
          <div class="switch-tip" v-if="searchType === 1 && !selectedItem" @click="switchToItem">
            试试搜事项 →
          </div>
        </div>
      </div>
      </div><!-- scroll-content 结束 -->
    </div>
  </van-popup>
</template>

<script>
import { Popup, ActionSheet, Icon, Toast } from 'vant';
import { searchSite, getHotProjectList, getHotSiteList, addProjectClick, addSiteClick, searchProject } from '@/api/apis';
import {
  hotSearchList as mockHotSearchList,
  itemList as mockItemList,
  siteList as mockSiteList,
  correctionDict,
  colloquialDict,
  pinyinDict
} from '@/mock/siteData';

export default {
  name: 'SiteSearch',
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon
  },
  props: {
    value: { type: Boolean, default: false },
    siteList: { type: Array, default: () => [] }
  },
  data() {
    return {
      keyword: '',
      searchType: 1,
      searchName: '搜政务中心',
      showTypeSheet: false,
      showResult: false,
      resultList: [],
      itemResultList: [],  // 事项搜索结果
      hotList: [],
      historyList: [],
      searchTypes: [
        { name: '搜政务中心', type: 1 },
        { name: '搜事项', type: 2 }
      ],
      selectedItem: null,  // 选中的事项
      smartTip: '',  // 智能转换提示
      showSuggest: false,  // 是否显示联想列表
      suggestList: [],  // 联想列表数据
      suggestTimer: null,  // 防抖定时器
      aiChatUrl: 'https://videotrtc.egovrobot.com/v1/chat-messages',  // AI推荐接口
      aiLoading: false,  // AI接口加载状态
      
      // 语音识别相关
      supportVoice: false,
      isRecording: false,
      recognition: null
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.showResult = false;
        this.keyword = '';
        this.showSuggest = false;
        this.suggestList = [];
        this.loadHotSearch();
        this.loadHistory();
        this.initVoiceRecognition();
      }
    }
  },
  methods: {
    onTypeSelect(item) {
      this.searchType = item.type;
      this.searchName = item.name;
      this.showTypeSheet = false;
      this.loadHotSearch();
    },
    async loadHotSearch() {
      try {
        if (this.searchType === 1) {
          // 搜政务中心 - 获取热门站点
          const res = await getHotSiteList({ limit: 5 });
          if (res.data && res.data.success && res.data.obj) {
            this.hotList = res.data.obj.map(item => ({
              id: item.siteId,
              searchWord: item.siteName,
              searchType: 1
            }));
          } else {
            this.hotList = mockHotSearchList.filter(item => item.searchType === 1);
          }
        } else {
          // 搜事项 - 获取热门事项
          const res = await getHotProjectList({ limit: 5 });
          if (res.data && res.data.success && res.data.obj) {
            this.hotList = res.data.obj.map(item => ({
              id: item.projectId,
              searchWord: item.projectName,
              searchType: 2
            }));
          } else {
            this.hotList = mockHotSearchList.filter(item => item.searchType === 2);
          }
        }
      } catch (error) {
        console.error('获取热门搜索失败:', error);
        this.hotList = mockHotSearchList.filter(item => item.searchType === this.searchType);
      }
    },
    loadHistory() {
      const saved = localStorage.getItem('searchHistory');
      this.historyList = saved ? JSON.parse(saved) : [];
    },
    quickSearch(word) {
      this.keyword = word;
      this.showSuggest = false;
      this.doSearch();
    },
    // 输入变化时触发联想
    onInputChange() {
      if (this.suggestTimer) {
        clearTimeout(this.suggestTimer);
      }
      const kw = this.keyword.trim();
      if (!kw) {
        this.showSuggest = false;
        this.suggestList = [];
        return;
      }
      // 防抖300ms
      this.suggestTimer = setTimeout(() => {
        this.loadSuggest(kw);
      }, 300);
    },
    // 加载联想数据
    async loadSuggest(kw) {
      try {
        if (this.searchType === 1) {
          // 搜政务中心 - 调用搜索接口
          const res = await searchSite({ keyword: kw, limit: 5, areaCode: window.config?.areaCode });
          if (res.data && res.data.success && res.data.obj) {
            this.suggestList = res.data.obj.slice(0, 5);
          } else {
            // 本地搜索
            const searchList = this.siteList.length > 0 ? this.siteList : mockSiteList;
            this.suggestList = searchList.filter(site => 
              this.fuzzyMatch(site.siteName, kw) || this.fuzzyMatch(site.address, kw)
            ).slice(0, 5);
          }
        } else {
          // 搜事项 - 本地模糊搜索
          this.suggestList = mockItemList.filter(item => 
            this.fuzzyMatch(item.name, kw) || this.fuzzyMatch(item.category, kw)
          ).slice(0, 5);
        }
        this.showSuggest = this.suggestList.length > 0;
      } catch (error) {
        console.error('加载联想失败:', error);
        this.showSuggest = false;
      }
    },
    // 选择联想项
    selectSuggest(item) {
      if (this.searchType === 1) {
        // 政务中心直接选中
        this.selectSite(item);
      } else {
        // 事项填入关键词并搜索
        this.keyword = item.name;
        this.showSuggest = false;
        this.doSearch();
      }
    },
    // 模糊匹配函数
    fuzzyMatch(text, keyword) {
      if (!text || !keyword) return false;
      const t = text.toLowerCase();
      const k = keyword.toLowerCase().trim();
      // 支持多关键词（空格分隔）
      const keywords = k.split(/\s+/);
      return keywords.every(kw => t.includes(kw));
    },
    // 智能转换关键词
    smartConvert(keyword) {
      let converted = keyword;
      let tip = '';
      
      // 1. 纠错检查
      for (const [wrong, correct] of Object.entries(correctionDict)) {
        if (keyword.includes(wrong)) {
          converted = keyword.replace(wrong, correct);
          tip = `已纠正为"${correct}"`;
          break;
        }
      }
      
      // 2. 百姓体转化
      if (!tip) {
        for (const [colloquial, formal] of Object.entries(colloquialDict)) {
          if (keyword.includes(colloquial) || keyword === colloquial) {
            converted = formal;
            tip = `已转换为"${formal}"`;
            break;
          }
        }
      }
      
      // 3. 拼音转化
      if (!tip) {
        const lowerKw = keyword.toLowerCase();
        for (const [pinyin, chinese] of Object.entries(pinyinDict)) {
          if (lowerKw.includes(pinyin) || lowerKw === pinyin) {
            converted = keyword.toLowerCase().replace(pinyin, chinese);
            tip = `已识别为"${chinese}"`;
            break;
          }
        }
      }
      
      return { converted, tip };
    },
    async doSearch() {
      console.log('doSearch called, keyword:', this.keyword, 'searchType:', this.searchType);
      if (!this.keyword.trim()) {
        Toast('请输入搜索关键字');
        return;
      }
      this.showSuggest = false;
      this.saveKeyword();
      this.selectedItem = null;
      
      // 智能转换关键词
      const { converted, tip } = this.smartConvert(this.keyword.trim());
      const kw = converted;
      this.smartTip = tip;
      
      if (this.searchType === 1) {
        // 搜政务中心 - 调用搜索接口
        try {
          const res = await searchSite({ keyword: kw, limit: 20, areaCode: window.config?.areaCode });
          if (res.data && res.data.success && res.data.obj) {
            this.resultList = res.data.obj;
          } else {
            // 接口无数据，使用本地搜索
            this.searchLocal(kw);
          }
        } catch (error) {
          console.error('搜索网点失败:', error);
          // 接口失败，使用本地搜索
          this.searchLocal(kw);
        }
        this.itemResultList = [];
      } else {
        // 搜事项 - 先调用AI推荐接口，再搜索事项
        try {
          // 1. 调用AI推荐接口（显示loading）
          Toast.loading({ message: '智能匹配中...', forbidClick: true, duration: 0 });
          const aiKeywords = await this.getAiRecommendKeywords(kw);
          Toast.clear();
          const searchKeyword = aiKeywords.length > 0 ? aiKeywords[0] : kw;
          console.log('AI推荐关键词:', aiKeywords, '使用关键词:', searchKeyword);
          
          // 2. 使用AI返回的关键词搜索事项
          const res = await searchProject({ 
            keyword: searchKeyword, 
            pageNum: 1, 
            pageSize: 20, 
            areaCode: window.config?.areaCode 
          });
          if (res.data && res.data.success && res.data.obj) {
            const list = res.data.obj.list || res.data.obj;
            if (Array.isArray(list) && list.length > 0) {
              this.itemResultList = list.map(item => ({
                id: item.projectId,
                projectId: item.projectId,
                projectNo: item.projectNo,
                name: item.projectName,
                category: item.projectType || '政务服务',
                recommend: item.tagApp ? 'mobile' : (item.tagNet ? 'pc' : (item.tagAgm ? 'self' : 'hall')),
                siteIds: [], // 接口返回的事项没有siteIds，点击后需要单独查询
                tagWindow: item.tagWindow,
                tagNet: item.tagNet,
                tagApp: item.tagApp,
                tagAgm: item.tagAgm
              }));
            } else {
              // 接口无数据，显示空结果
              this.itemResultList = [];
            }
          } else {
            // 接口返回失败，显示空结果
            this.itemResultList = [];
          }
        } catch (error) {
          Toast.clear();
          console.error('搜索事项失败:', error);
          // 接口失败，显示空结果
          this.itemResultList = [];
        }
        this.resultList = [];
      }
      this.showResult = true;
    },
    // 调用AI推荐接口获取事项关键词（blocking模式）
    async getAiRecommendKeywords(query) {
      try {
        const userId = localStorage.getItem('userId') || localStorage.getItem('qa_user_id') || `user_${Date.now()}`;
        const apiKey = 'app-BzDidfxMbRp6qMGnO5QWvuOr';
        
        const requestData = {
          query: query,
          user: userId,
          inputs: {},
          response_mode: 'blocking'
        };
        
        console.log('AI推荐接口请求:', this.aiChatUrl, requestData);
        
        const response = await fetch(this.aiChatUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apiKey}`
          },
          body: JSON.stringify(requestData)
        });
        
        if (!response.ok) {
          console.error('AI推荐接口请求失败:', response.status);
          return [];
        }
        
        const data = await response.json();
        console.log('AI推荐接口返回:', data);
        
        // 解析answer字段中的JSON
        if (data && data.answer) {
          try {
            const answerData = JSON.parse(data.answer);
            if (answerData.projectList && Array.isArray(answerData.projectList)) {
              console.log('AI推荐关键词:', answerData.projectList);
              return answerData.projectList;
            }
          } catch (e) {
            console.log('解析answer失败:', e);
          }
        }
        
        return [];
      } catch (error) {
        console.error('调用AI推荐接口失败:', error);
        return [];
      }
    },
    // 本地搜索（接口失败时的降级方案）
    searchLocal(kw) {
      const searchList = this.siteList.length > 0 ? this.siteList : mockSiteList;
      this.resultList = searchList.filter(site => 
        this.fuzzyMatch(site.siteName, kw) || 
        this.fuzzyMatch(site.address, kw)
      );
    },
    // 获取办理方式标签
    getHandleLabel(way) {
      const labels = { mobile: '手机办', pc: '电脑办', self: '自助办', hall: '大厅办' };
      return labels[way] || way;
    },
    // 选择事项，显示可办理网点或跳转详情
    selectItem(item) {
      console.log('selectItem called:', item);
      // 增加事项点击量
      if (item.id || item.projectId) {
        addProjectClick({ projectId: item.id || item.projectId }).catch(err => console.log('增加事项点击量失败:', err));
      }
      
      // 如果是接口返回的事项（没有siteIds或siteIds为空），跳转到办事指南详情
      if (!item.siteIds || item.siteIds.length === 0) {
        this.visible = false;
        this.$router.push({
          path: '/guideDetail',
          query: { 
            id: item.projectId || item.id, 
            name: item.name,
            projectNo: item.projectNo
          }
        });
        return;
      }
      
      // 如果有siteIds，显示可办理网点
      this.selectedItem = item;
      
      // 根据事项的siteIds筛选可办理网点
      const searchList = this.siteList.length > 0 ? this.siteList : mockSiteList;
      
      if (item.siteIds && item.siteIds.length > 0) {
        this.resultList = searchList.filter(site => {
          const siteId = site.id || site.siteId;
          return item.siteIds.includes(siteId);
        });
      } else {
        this.resultList = searchList;
      }
      console.log('resultList:', this.resultList.length);
    },
    saveKeyword() {
      const keyword = this.keyword.trim();
      if (!keyword) return;
      
      // 从 localStorage 获取历史记录
      let history = JSON.parse(localStorage.getItem('searchHistory') || '[]');
      
      // 如果已存在，先移除
      const index = history.indexOf(keyword);
      if (index > -1) {
        history.splice(index, 1);
      }
      
      // 添加到最前面
      history.unshift(keyword);
      
      // 最多保存10条
      if (history.length > 10) {
        history = history.slice(0, 10);
      }
      
      // 保存到 localStorage
      localStorage.setItem('searchHistory', JSON.stringify(history));
      this.historyList = history;
    },
    // 删除单条历史记录
    removeHistory(index) {
      this.historyList.splice(index, 1);
      localStorage.setItem('searchHistory', JSON.stringify(this.historyList));
    },
    // 清空历史记录
    clearHistory() {
      this.historyList = [];
      localStorage.removeItem('searchHistory');
    },
    selectSite(site) {
      // 增加站点点击量
      if (site.id) {
        addSiteClick({ siteId: site.id }).catch(err => console.log('增加站点点击量失败:', err));
      }
      this.$emit('select', site);
      this.visible = false;
      this.keyword = '';
      this.showResult = false;
    },
    backToSearch() {
      this.showResult = false;
    },
    // 处理返回按钮点击
    handleBack() {
      if (this.selectedItem) {
        this.selectedItem = null;
        this.resultList = [];
      } else {
        this.showResult = false;
      }
    },
    // 切换到搜事项模式并重新搜索
    switchToItem() {
      this.searchType = 2;
      this.searchName = '搜事项';
      this.doSearch();
    },
    
    // 初始化语音识别
    initVoiceRecognition() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      
      console.log('搜索弹层-检查语音识别支持:', SpeechRecognition ? '支持' : '不支持');
      
      if (!SpeechRecognition) {
        this.supportVoice = false;
        return;
      }
      
      this.supportVoice = true;
      console.log('搜索弹层-语音识别已启用');
      
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'zh-CN';
      this.recognition.continuous = false;
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;
      
      this.recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        console.log('语音识别结果:', transcript);
        this.keyword = transcript;
        this.isRecording = false;
        Toast.success(`识别成功：${transcript}`);
        
        // 自动触发搜索
        setTimeout(() => {
          this.doSearch();
        }, 500);
      };
      
      this.recognition.onerror = (event) => {
        console.error('语音识别错误:', event.error);
        this.isRecording = false;
        
        let errorMsg = '语音识别失败';
        switch(event.error) {
          case 'no-speech':
            errorMsg = '未检测到语音，请重试';
            break;
          case 'audio-capture':
            errorMsg = '无法访问麦克风';
            break;
          case 'not-allowed':
            errorMsg = '麦克风权限被拒绝';
            break;
          case 'network':
            errorMsg = '网络错误，请检查网络连接';
            break;
        }
        Toast.fail(errorMsg);
      };
      
      this.recognition.onend = () => {
        this.isRecording = false;
      };
      
      this.recognition.onstart = () => {
        this.isRecording = true;
        Toast.loading({
          message: '正在聆听...',
          forbidClick: true,
          duration: 0
        });
      };
    },
    
    // 切换语音搜索
    toggleVoiceSearch() {
      if (!this.supportVoice) {
        Toast.fail('当前浏览器不支持语音识别，请使用Chrome或Edge浏览器');
        return;
      }
      
      if (this.isRecording) {
        this.recognition.stop();
        Toast.clear();
      } else {
        try {
          this.recognition.start();
        } catch (error) {
          console.error('启动语音识别失败:', error);
          Toast.fail('启动语音识别失败，请重试');
        }
      }
    }
  },
  
  beforeDestroy() {
    if (this.recognition) {
      this.recognition.stop();
      this.recognition = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.slayerContent {
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 100%;
  overflow: hidden;
}

.search-header {
  position: sticky;
  top: 0;
  background: #fff;
  padding: 12px 16px;
  z-index: 10;
  border-bottom: 1px solid #f0f0f0;
  
  .suggest-list {
    position: absolute;
    left: 16px;
    right: 16px;
    top: 60px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    
    .suggest-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 14px;
      border-bottom: 1px solid #f5f5f5;
      
      &:last-child {
        border-bottom: none;
      }
      
      span {
        flex: 1;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      &:active {
        background: #f5f5f5;
      }
    }
  }
}

.scroll-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
}

.searchInput {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 0 12px;
  height: 44px;
  
  .searchLeft {
    display: flex;
    align-items: center;
    color: #1989fa;
    font-size: 14px;
    padding-right: 12px;
    border-right: 1px solid #ddd;
    flex-shrink: 0;
    white-space: nowrap;
    
    span {
      white-space: nowrap;
    }
    
    label {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid #1989fa;
      margin-left: 4px;
    }
  }
  
  .searchRight {
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 12px;
    gap: 8px;
    
    input {
      flex: 1;
      border: none;
      background: transparent;
      font-size: 14px;
      outline: none;
    }
    
    .voice-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      color: #1989fa;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:active {
        transform: scale(0.9);
      }
      
      &.recording {
        animation: pulse 1.5s ease-in-out infinite;
        color: #ff4444;
      }
      
      &.disabled {
        color: #ccc;
        cursor: not-allowed;
      }
    }
    
    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.8;
      }
    }
    
    label {
      color: #1989fa;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      
      &:active {
        opacity: 0.7;
      }
    }
  }
}

.hotsearch {
  margin-top: 16px;
  
  .hotsearchTitle {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
    
    span {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
  
  .hotsearchList {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    
    .hotsearchItem {
      padding: 6px 16px;
      background: linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%);
      color: #fff;
      border-radius: 20px;
      font-size: 13px;
    }
  }
}

.historysearch {
  .historysearchTitle {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    span {
      width: 3px;
      height: 14px;
      background: #1989fa;
      margin-right: 8px;
    }
    
    label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      flex: 1;
    }
    
    i {
      font-size: 13px;
      color: #999;
      font-style: normal;
    }
  }
  
  .historyResult {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    
    .history-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 10px 6px 14px;
      background: #f5f5f5;
      border-radius: 4px;
      
      span {
        font-size: 13px;
        color: #666;
      }
    }
  }
  
  .historyResult1 {
    color: #999;
    font-size: 13px;
  }
}

.smart-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff7e6;
  border-radius: 6px;
  margin-bottom: 12px;
  
  span {
    font-size: 13px;
    color: #fa8c16;
  }
}

.searchResultBox {
  margin-top: 16px;
  
  .historysearchTitle {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    span {
      width: 3px;
      height: 14px;
      background: #1989fa;
      margin-right: 8px;
    }
    
    label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      flex: 1;
    }
    
    i {
      color: #1989fa;
      font-size: 13px;
      font-style: normal;
    }
  }
  
  .historyResList {
    max-height: calc(100% - 100px);
    overflow-y: auto;
  }
  
  .historyResItem {
    padding: 12px;
    background: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 10px;
    
    .historyResItemTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      
      span {
        font-size: 15px;
        font-weight: 500;
        color: #333;
      }
    }
    
    .historyResItemContent {
      font-size: 12px;
      color: #666;
      
      > div {
        display: flex;
        align-items: flex-start;
        margin-bottom: 4px;
        
        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          margin-top: 2px;
        }
        
        span {
          flex: 1;
          line-height: 1.4;
        }
      }
    }
  }
}

.noResult {
  padding: 40px 0;
  text-align: center;
  
  .empty-icon {
    margin-bottom: 16px;
  }
  
  .empty-text {
    color: #999;
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .switch-tip {
    color: #1989fa;
    font-size: 14px;
    cursor: pointer;
  }
}

.itemResList {
  margin-bottom: 12px;
}

.itemResCard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 10px;
  
  .item-info {
    flex: 1;
    
    .item-name {
      font-size: 15px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
    
    .item-tags {
      display: flex;
      gap: 8px;
    }
  }
  
  .item-arrow {
    display: flex;
    align-items: center;
    gap: 4px;
    
    .site-count {
      font-size: 12px;
      color: #1989fa;
    }
  }
}

.category-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: #f0f0f0;
  color: #666;
}

.recommend-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  color: #fff;
  
  &.mobile { background: #07c160; }
  &.pc { background: #1989fa; }
  &.self { background: #ff976a; }
  &.hall { background: #ee0a24; }
}
</style>
